module.exports = __webpack_public_path__ + "static/banner-girl-2cc8748faac91537d1663386ba5035b3.jpg";